import { render, staticRenderFns } from "./webPaymentConfig.vue?vue&type=template&id=3b44bb72&lang=html"
import script from "./webPaymentConfig.vue?vue&type=script&lang=js"
export * from "./webPaymentConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports